module.exports = __webpack_public_path__ + "img/nike-red.db4ea300.png";